import Vue from 'vue';
import Router from 'vue-router';
import Api from './utils/api';

// Views
import Login from './views/Login';
import ForgotPassword from './views/ForgotPassword';
import ResetPassword from "./views/ResetPassword";

import Home from './views/Home';
import AgendaView from './views/Agenda/AgendaView';
import AgendaConfirmations from './views/Agenda/AgendaConfirmations';
import AgendaConfigList from './views/Agenda/AgendaConfigList';
import AgendaConfigForm from './views/Agenda/AgendaConfigForm';

import PersonList from './views/Person/PersonList';
import PersonForm from './views/Person/PersonForm';

import TransactionList from './views/Financial/TransactionList';
import TransactionForm from './views/Financial/TransactionForm';

import CashFlow from './views/Financial/CashFlow';

import Dashboard from './views/Dashboard/Dashboard';

import ClientForm from './views/Client/ClientForm';

import SubscriptionForm from './views/Subscription/SubscriptionForm';

import FormConfigList from './views/Form/FormConfigList';
import FormConfigForm from './views/Form/FormConfigForm';
import SellerList from "@/views/Seller/SellerList";
import SellerForm from "@/views/Seller/SellerForm";
import InvoiceList from "@/views/Invoice/InvoiceList";
import InvoiceView from "@/views/Invoice/InvoiceView";
import ProcedureList from "./views/Procedure/ProcedureList";
import ProcedureForm from "./views/Procedure/ProcedureForm";
import HealthPlanList from "./views/HealthPlan/HealthPlanList";
import HealthPlanForm from "./views/HealthPlan/HealthPlanForm";
import WhatsappForm from "./views/Whatsapp/WhatsappForm";
import WhatsappList from "./views/Whatsapp/WhatsappList";
import AttendanceGuidePrint from "./views/AttendanceGuide/AttendanceGuidePrint";
import AttendanceGuideInvoicePrint from "./views/AttendanceGuide/AttendanceGuideInvoicePrint";
import AttendanceGuideList from "./views/AttendanceGuide/AttendanceGuideList";
import ProfessionalDigitalCardForm from "./views/Person/ProfessionalDigitalCardForm";
import ClientDigitalCardForm from "./views/Client/ClientDigitalCardForm";
import Onboarding from "./views/Onboarding";
import PatientTelehealthAttendance from "./views/Person/PatientTelehealthAttendance";
import HomeDashboard from "./views/Home/Dashboard";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/esqueci-a-senha',
      component: ForgotPassword
    },
    {
      path: '/redefinir-senha/:token',
      component: ResetPassword
    },
    {
      path: '/primeiros-passos',
      component: Onboarding,
      meta: { requiresAuth: true }
    },
    {
      path: '/guia-de-atendimento/:id/imprimir',
      component: AttendanceGuidePrint,
      meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true }
    },
    {
      path: '/guia-de-atendimento/fatura/:id/imprimir',
      component: AttendanceGuideInvoicePrint,
      meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true }
    },
    {
      path: '/pacientes/:patientId/teleconsulta/:id',
      component: PatientTelehealthAttendance,
      meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true }
    },
    {
      path: '/',
      component: Home,
      children: [
        { path: '', component: AgendaView, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'confirmacoes', component: AgendaConfirmations, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'configurar-agenda', component: AgendaConfigList, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'configurar-agenda/:id', component: AgendaConfigForm, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'dashboard', component: HomeDashboard, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'pacientes', component: PersonList, meta: { type: 'PATIENT', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'pacientes/:id', component: PersonForm, meta: { type: 'PATIENT', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'profissionais', component: PersonList, meta: { type: 'PROFESSIONAL', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'profissionais/:id', component: PersonForm, meta: { type: 'PROFESSIONAL', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'profissionais/:id/cartao-digital', component: ProfessionalDigitalCardForm, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'secretarias', component: PersonList, meta: { type: 'SECRETARY', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'secretarias/:id', component: PersonForm, meta: { type: 'SECRETARY', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'coordenadores', component: PersonList, meta: { type: 'COORDINATOR', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'coordenadores/:id', component: PersonForm, meta: { type: 'COORDINATOR', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'guias-de-atendimento', component: AttendanceGuideList, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'financeiro/contas-a-receber', component: TransactionList, meta: { type: 'INCOME', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'financeiro/contas-a-receber/:id', component: TransactionForm, meta: { type: 'INCOME', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'financeiro/contas-a-pagar', component: TransactionList, meta: { type: 'EXPENSE', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'financeiro/contas-a-pagar/:id', component: TransactionForm, meta: { type: 'EXPENSE', requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'financeiro/fluxo-de-caixa', component: CashFlow, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'painel-de-controle', component: Dashboard, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'cobrancas/transacoes', component: InvoiceList, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'cobrancas/transacoes/:id', component: InvoiceView, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'cobrancas/contas-de-cobranca', component: SellerList, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'cobrancas/contas-de-cobranca/:id', component: SellerForm, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'prontuarios', component: FormConfigList, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'prontuarios/:id', component: FormConfigForm, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'convenios', component: HealthPlanList, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'convenios/:id', component: HealthPlanForm, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'procedimentos', component: ProcedureList, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'procedimentos/:id', component: ProcedureForm, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'contas-de-whatsapp', component: WhatsappList, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },
        { path: 'contas-de-whatsapp/:id', component: WhatsappForm, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'informacoes-pessoais', component: PersonForm, meta: { requiresAuth: true, requiresOnboarding: true } },
        { path: 'dados-do-consultorio', component: ClientForm, meta: { requiresAuth: true, requiresOnboarding: true } },
        { path: 'dados-do-consultorio/cartao-digital', component: ClientDigitalCardForm, meta: { requiresAuth: true, requiresOnboarding: true, blockSuspended: true } },

        { path: 'minha-assinatura', component: SubscriptionForm, meta: { requiresAuth: true, requiresOnboarding: true } }
      ],
      meta: { requiresAuth: true }
    }
  ]
});

router.beforeEach((to, from, next) => {
  Api.checkVersion();

  if (to.matched.some(record => record.meta.requiresAuth) && !Api.isLogged()) {
    next({path: '/login'});
  }
  else if (to.matched.some(record => record.meta.requiresOnboarding) && !Api.hasOnboarded()) {
    next({path: '/primeiros-passos'});
  }
  else if (to.matched.some(record => record.meta.blockSuspended) && Api.isSuspended()) {
    next({path: '/minha-assinatura'});
  }
  else {
    next();
  }
});

// router.afterEach((to, from) => {
//   if(to.meta.requiresAuth && Api.checkTrial(to) && to.path != from.path) {
//     router.push({ path: '/minha-assinatura' });
//   }
// });

export default router
